import { getImageReference } from "@tiicker/util/lib/contentful/helpers";
import {
  ContentfulContentType,
  VideoSectionDocument,
} from "@tiicker/util/lib/contentful/types";
import VideoPlayer from "components/VideoPlayer/VideoPlayer";
import React from "react";
import { useContentfulEntries } from "source/contentful/provider";

type Props = {
  videoIds: string[];
  noRow?: boolean;
  stopAutoplay?: boolean;
  thumbnailClassName?: string;
};

const VideoLoader = (props: Props) => {
  const videos = useContentfulEntries<VideoSectionDocument>(
    ContentfulContentType.VideoSection,
    {
      query: {
        content_type: ContentfulContentType.VideoSection,
        "sys.id[in]": props.videoIds.join(","),
      },
    }
  );

  if (videos.state !== "DONE") {
    return <></>;
  }

  // if (props.noRow) {
  return (
    <>
      {props.videoIds.map((videoId, index, fullArray) => {
        const video = videos.result.items.find((v) => v.sys.id === videoId);

        if (!video) {
          console.error("No video found for ID", videoId);
          return <></>;
        }

        const thumbnail = getImageReference(
          video.fields.imageThumbnail,
          videos.result.includes
        );

        const isFirstOdd = index === 0 && (fullArray.length - 1) % 2 === 0;

        return (
          <VideoPlayer
            thumbnailUrl={thumbnail?.fields.file.url || ""}
            thumbnailClassName={props.thumbnailClassName}
            video={video.fields.videoUpload}
            videoUrl={video.fields.videoUrl}
            inline={video.fields.isInline}
            stopAutoplay={props.stopAutoplay}
          />
        );
      })}
    </>
  );
  // }

  // return (
  //   <Row gutter={[40, 40]}>
  //     {props.videoIds.map((videoId, index, fullArray) => {
  //       const video = videos.result.items.find((v) => v.sys.id === videoId);

  //       if (!video) {
  //         console.error("No video found for ID", videoId);
  //         return <></>;
  //       }

  //       const thumbnail = getImageReference(
  //         video.fields.imageThumbnail,
  //         videos.result.includes
  //       );

  //       const isFirstOdd = index === 0 && (fullArray.length - 1) % 2 === 0;

  //       return (
  //         <Col
  //           key={`video-${video.sys.id}`}
  //           md={{ span: isFirstOdd ? 24 : 12 }}
  //           span={24}
  //         >
  //           <VideoPlayer
  //             thumbnailUrl={thumbnail?.fields.file.url || ""}
  //             thumbnailClassName={props.thumbnailClassName}
  //             video={video.fields.videoUpload}
  //             videoUrl={video.fields.videoUrl}
  //             inline={video.fields.isInline}
  //             stopAutoplay={props.stopAutoplay}
  //           />
  //         </Col>
  //       );
  //     })}
  //   </Row>
  // );
};

export default VideoLoader;
